import { Syntax } from '@trlogic/ui-pack';
import { ActionToken, ConditionToken, EventToken, PriorityToken, ResolutionToken } from '../domain/collection/rule/RuleDomains';

class WorkflowNodeUtil {
  public static getTransaction(workflow: Syntax): Syntax<EventToken> | undefined {
    return this.getStart(workflow)?.children?.[0] as Syntax<EventToken> | undefined;
  }

  public static getPriority(workflow: Syntax): Syntax<PriorityToken> | undefined {
    return this.getTransaction(workflow)?.children?.[0] as Syntax<PriorityToken> | undefined;
  }

  public static getCondition(workflow: Syntax): Syntax<ConditionToken> | undefined {
    return this.getPriority(workflow)?.children?.[0] as Syntax<ConditionToken> | undefined;
  }

  public static getResolution(workflow: Syntax): Syntax<ResolutionToken> | undefined {
    return this.getCondition(workflow)?.children?.[0] as Syntax<ResolutionToken> | undefined;
  }

  public static getAction(workflow: Syntax): Syntax<ActionToken> | undefined {
    return this.getResolution(workflow)?.children?.[0] as Syntax<ActionToken> | undefined;
  }

  private static getStart(workflow: Syntax) {
    return workflow;
  }
}

export default WorkflowNodeUtil;
